import { Sidebar } from '@payaca/ambrosia';
import {
  PublicHydratedEntityTemplate,
  TemplatableEntity,
} from '@payaca/types/entity-templates';
import { FC, type JSX } from 'react';
import EntityTemplateReadView from '../entityTemplateReadView/EntityTemplateReadView';

type Props = {
  entityTemplate: PublicHydratedEntityTemplate<TemplatableEntity>;
  onDeleteEntityTemplateSuccess?: () => void;
  onUpdateEntityTemplateSuccess?: (
    updatedEntityTemplate: PublicHydratedEntityTemplate<TemplatableEntity>
  ) => void;
  isOpen: boolean;
  onClose?: () => void;
  allowModifyTemplateNameDescription?: boolean;
};

const EntityTemplateReadDrawer: FC<Props> = ({
  entityTemplate,
  onDeleteEntityTemplateSuccess,
  onUpdateEntityTemplateSuccess,
  isOpen,
  onClose,
  allowModifyTemplateNameDescription,
}: Props): JSX.Element | null => {
  return (
    <Sidebar isOpen={isOpen} onClose={onClose}>
      <Sidebar.Body className="p-4">
        {entityTemplate && (
          <EntityTemplateReadView
            allowModifyTemplateNameDescription={
              allowModifyTemplateNameDescription
            }
            initialEntityTemplate={entityTemplate}
            onUpdateEntityTemplateSuccess={onUpdateEntityTemplateSuccess}
            onDeleteEntityTemplateSuccess={onDeleteEntityTemplateSuccess}
          />
        )}
      </Sidebar.Body>
    </Sidebar>
  );
};
export default EntityTemplateReadDrawer;
